export default {"src":"/_next/static/media/plus-button-shop.96993e9b.svg","height":40,"width":40};